<script>
	const utilities = require('utilities');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const PARENT_DONATE_POPUP_OPENED = analyticsUtilities.events.PARENT_DONATE_POPUP_OPENED;

	module.exports = {
		components: {
			kindful: require('components/kindful.vue').default
		},
		modelData: ['offlineMode'],
		data() {
			return {
				role: null,
				nonK12: null,
				other: null,
				open: false
			};
		},
		computed: {
			formId() {
				const groupId = this.role;

				if (this.nonK12) {
					return 'e7820ed5-35d7-4859-928d-a60c6554e78a';
				}

				const formIdDict = {
					384: '31ff5078-255f-4b41-9b90-1528f25043ad', // tutors
					191963: '3bb59c56-8b1a-4cc1-abd9-d04e1009f674', // homeschoolers
					385: '3bb59c56-8b1a-4cc1-abd9-d04e1009f674', // parents
					393: '0c9b0f19-4f81-4b74-8170-1bdc0a8d39ee' // other
				};

				return formIdDict[groupId] || '8ada1442-da73-4b99-b62f-d12df8e48bb3';
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-donation-parent') {
					return true; // let some other handler take this
				}

				fireEvent(PARENT_DONATE_POPUP_OPENED);

				opts = opts || {};
				this.open = true;
				this.role = opts.role ? parseInt(opts.role) : null;
				this.nonK12 = !!opts.nonK12;
				this.other = !!opts.other;

				return false;
			});
			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-donation-parent') {
					return true; // let some other handler take this
				}

				this.open = false;
				this.role = null;
				this.nonK12 = null;
				this.other = null;

				return false;
			});
		},
		methods: {
			closeModal() {
				utilities.closeModals();
			}
		}
	};
</script>
<template>
	<div>
		<modal
			ref="modal"
			id="modal-donation-parent"
			:ok="false"
			:centered="true">
			<div
				slot="content"
				class="donation-parent-modal-body">
				<kindful
					v-if="offlineMode === false && open && formId"
					:form-id="formId">
				</kindful>
				<button
					class="button -centered margin-top-medium -outline"
					@click="closeModal">
					Close
				</button>
			</div>
		</modal>
	</div>
</template>
